type CreateMemberFormErrors = Record<string, string>;

export const getCreateMemberErrorsAfterMembershipTypeChange = (
  current: CreateMemberFormErrors,
): CreateMemberFormErrors => {
  const nextErrors = { ...current };
  delete nextErrors.membershipTypeId;
  return nextErrors;
};

export const getCreateMemberErrorsAfterEmailConsentChange = (
  current: CreateMemberFormErrors,
  checked: boolean,
): CreateMemberFormErrors => {
  if (!checked) return current;

  const nextErrors = { ...current };
  delete nextErrors.emailCommunicationConsentConfirmed;
  return nextErrors;
};

// A required field error clears when staff enter a value in that field.
export const getCreateMemberErrorsAfterRequiredValueChange = (
  current: CreateMemberFormErrors,
  errorKey: string,
  value: string,
): CreateMemberFormErrors => {
  if (!value.trim() || !(errorKey in current)) return current;

  const nextErrors = { ...current };
  delete nextErrors[errorKey];
  return nextErrors;
};
